/*
 * jQuery sticky box plugin
 */
;(function($, $win) {
    var extensionMethods = {

        getTopPosition: function() {
            var headerElem = 'header.header-v3';
            var headerElement = this.IsHeaderElementVisible(headerElem);
            var currExtraTop = 0;

            if (headerElement && $(headerElem).length) {
                currExtraTop = $(headerElem).innerHeight();
            } else {
                currExtraTop = this.extraTop;
            }
            if (this.moveInContainer) {
                var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
                return Math.min(currExtraTop, (this.data.containerHeight + this.data.containerOffsetTop) - currScrollTop);
            } else {
                return currExtraTop;
            }
        },
        IsHeaderElementVisible: function(headerElem) {
            if (typeof headerElem === 'undefined') return;
            var $el = $(headerElem);
            return !($el.is(":hidden") || $el.css("visibility") === "hidden" || $el.css('opacity') === 0);
        }
    };
    setTimeout(function() { $.extend(window.StickyScrollBlock.prototype, extensionMethods)}, 400);

}(jQuery, jQuery(window)));
